// 웹 접수(치과 데스크 QR → 비회원 접수) 공용 상수·검증·문구 (2026-10-01 대표 확정, 기획서 부록 4 보강)
// 원칙: 입력값은 localStorage에 저장하지 않는다. 콘솔에 이름·휴대폰 번호를 남기지 않는다(오류 로그는 코드까지만).
// 의료법: 혜택·할인·무료·후기 표현 없음 — 사실 안내만.

// 내원 목적 — 선택지 고정 4종(자유입력 없음, 기획서 부록 4 보강 법무 절)
export const WALKIN_PURPOSES = [
    { key: 'checkup', label: '검진' },
    { key: 'consult', label: '상담' },
    { key: 'treatment', label: '치료' },
    { key: 'other', label: '기타' },
];
export const walkinPurposeLabel = (key) => (WALKIN_PURPOSES.find(p => p.key === key) || {}).label || '-';

// 보관 기간(기획서 부록 4 보강: 웹 접수 건은 7일 후 자동 삭제)
export const WALKIN_RETENTION_DAYS = 7;

// ── 동의 문안 정본 walkin-1.0 (법적보안 확정 2026-10-01, docs/위치기반서비스_이용약관_v1.2_초안_2026-10-01.md §5B-2)
// 원문 파일: docs/동의정본_웹접수_walkin-1.0_본문.txt — 아래 줄 배열은 그 파일과 바이트 동일(줄 끝 개행 없음, NFC).
// 해시 = 서버 consentBodyHash 방식(NFC·CRLF→LF·trim·sha256). 본문이 한 글자라도 바뀌면 walkin-1.1 새 버전 + 새 해시.
// {clinicName} 자리표시자는 해시 대상 원문에 그대로 두고, 화면 표시 때만 치환한다(walkinConsentText).
export const WALKIN_CONSENT_VERSION = 'walkin-1.0';
export const WALKIN_CONSENT_TEXT_HASH = '22744f93ba3abdb6fd63d0118c7b6c5c06d0a3796f84ffe8f07ae8fa1e0c887c';
export const WALKIN_CONSENT_TEXT = [
    "[필수] {clinicName}의 개인정보 수집·이용 동의 (접수)",
    "{clinicName}은(는) 오늘 접수와 호명을 위해 아래와 같이 개인정보를 수집·이용합니다.",
    "- 항목: 이름, 휴대폰 번호, 내원 목적(검진·상담·치료·기타 중 선택)",
    "- 목적: 오늘 접수 확인과 호명, 같은 휴대폰 번호로 덴탈클러스터 앱에 등록하는 경우 접수 건과 등록 정보의 연결",
    "- 보유 기간: 접수일부터 7일이 지나면 삭제합니다. 앱 등록과 연결된 경우에도 접수 내용은 7일 후 삭제되며, 등록 정보는 앱 등록 시 받는 동의에 따릅니다.",
    "- 처리 위탁: {clinicName}은(는) 이 정보의 처리를 주식회사 덴탈클러스터에 위탁하며, 덴탈클러스터는 데이터 저장과 서버 기능을 Google LLC에 재위탁합니다(국외(미국 등)에서 처리될 수 있습니다). 덴탈클러스터는 위탁 목적 외로 이용하지 않습니다.",
    "- 이 접수는 진료기록이 아니며, 진료에 관한 기록은 {clinicName}이(가) 별도로 작성·보존합니다.",
    "- 동의를 거부할 수 있으며, 거부하시면 데스크에서 종이로 접수하실 수 있습니다. 진료는 접수 방법과 관계없이 받으실 수 있습니다.",
].join('\n');
// 표시용 — {clinicName} 치환만. 줄 구조는 그대로(화면에서 white-space: pre-line 으로 줄바꿈)
export const walkinConsentText = (clinicName) =>
    WALKIN_CONSENT_TEXT.split('{clinicName}').join(String(clinicName || '이 치과').trim() || '이 치과');

// ── 접수 화면 비해시 문구 — 데스크 접수 정본 §3-1(2026-10-04)로 교체. 치과명을 못 읽었으면 '이 치과'
export const walkinHeaderLine = (clinicName) =>
    `이 접수 화면은 ${String(clinicName || '').trim() || '이 치과'}이(가) 운영하고, 주식회사 덴탈클러스터가 위탁받아 제공합니다.`;
export const WALKIN_AGE14_LABEL = '만 14세 이상입니다';
export const WALKIN_AGE14_HINT = '만 14세 미만 환자는 보호자가 데스크에서 종이로 접수해 주세요.';
export const WALKIN_AGREE_LABEL = '동의합니다';
export const walkinFooterLine = (clinicName) =>
    `적어 주신 정보의 보기·고치기·지우기 요청은 ${String(clinicName || '').trim() || '이 치과'} 데스크에 해 주세요. 덴탈클러스터는 의료기관이 아니며 진료에 관여하지 않습니다.`;

// ── 접수 완료 화면 (§5B-3 그대로)
export const walkinDoneTitle = (clinicName) => `${clinicName}에 접수되었습니다. 이름을 부르면 데스크로 와 주세요.`;
export const WALKIN_DONE_APP = '앱을 설치하면 문진·보철 기록을 볼 수 있습니다.';
export const WALKIN_DONE_LINK_HINT = '앱에서 같은 휴대폰 번호로 인증하면 오늘 접수와 연결됩니다. 접수 내용은 7일 후 삭제됩니다.';
export const walkinDoneContact = (clinicName) => `진료·예약·비용 문의는 ${clinicName}으로 해 주세요.`;

// ── 치과별 고정 QR 포스터 — 데스크 접수 정본 §3-3 + §7-3(끝 문장, 2026-10-04). 덴클 로고·앱 홍보·혜택 문장 금지
export const walkinPosterLine = (clinicName) =>
    `${clinicName} 접수 — 휴대폰 카메라로 QR을 찍어 접수해 주세요. 데스크에서 직접 접수하셔도 됩니다.`;
export const walkinPosterSmall = (clinicName) =>
    `접수 화면은 ${clinicName}이(가) 운영하며 주식회사 덴탈클러스터가 위탁받아 제공합니다. 접수 기록은 접수일부터 2년 보관합니다. 만 14세 미만은 부모님이 대신 적어 주세요.`;

// 휴대폰 번호 — 010-0000-0000 형식만 허용. 숫자만 받아 하이픈을 붙여 돌려준다.
export function formatWalkinPhoneInput(raw) {
    const d = String(raw || '').replace(/\D/g, '').slice(0, 11);
    if (d.length <= 3) return d;
    if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
    return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
}
export function isValidWalkinPhone(v) {
    return /^010-\d{4}-\d{4}$/.test(String(v || ''));
}
// 010-0000-0000 → +82100000000 (E.164, 첫 방문 등록(intake)과 같은 표기 — 앱 로그인 번호와 서버 병합 비교용)
export function toE164(v) {
    const d = String(v || '').replace(/\D/g, '');
    return d.startsWith('0') ? `+82${d.slice(1)}` : d;
}
// 서버 저장 E.164 → 010-0000-0000 표시용. 실패 시 원문
export function formatWalkinPhone(p) {
    const s = String(p || '');
    const m = s.match(/^\+82(\d{2})(\d{3,4})(\d{4})$/);
    return m ? `0${m[1]}-${m[2]}-${m[3]}` : s;
}

// 이름 — 서버 validateWalkinName 과 동일 규칙(계약 §F P2-7): NFC·trim 후 1~20자, 한글(완성형)·영문·공백만, 단어 ≤3개
// (숫자·기호·개행·탭은 서버 invalid-name, 주민번호 형식은 rrn-not-allowed)
export const WALKIN_NAME_HINT = '이름은 한글 또는 영문으로 20자 이내';
const WALKIN_NAME_RE = /^[가-힣a-zA-Z ]+$/;
export function isValidWalkinName(v) {
    const s = String(v || '').normalize('NFC').trim();
    if (s.length < 1 || s.length > 20) return false;
    if (!WALKIN_NAME_RE.test(s)) return false;
    return s.split(/ +/).filter(Boolean).length <= 3;
}

// slug 는 서버 발급(callable issueWalkinSlug — services/clinicWalkinApi.js). 클라이언트 생성·updateDoc 은 rules 로 거부됨(10-01 밤 P2-6)
export const WALKIN_BASE_URL = 'https://dental-lab-system.web.app/walkin/';
export const walkinUrl = (slug) => `${WALKIN_BASE_URL}${encodeURIComponent(slug || '')}`;

// 환자 화면 오류 문구 — 코드별. 환자(비전문가) 기준으로 짧고, 할 일(데스크에 말씀)을 함께 적는다
// details.code(세부) 판정을 code(대분류)보다 먼저 — consent-required 등은 failed-precondition 으로 오므로 순서가 바뀌면 엉뚱한 문구가 나간다
export function walkinErrorMessage(e, fallback) {
    const code = String(e?.code || '').replace(/^functions\//, '');
    const detail = e?.details?.code;
    if (detail === 'feature-off') return '지금은 웹 접수를 받지 않습니다. 데스크에 말씀해 주세요.';
    if (detail === 'age14-required') return WALKIN_AGE14_HINT;
    if (detail === 'consent-required' || detail === 'consent-version-not-accepted' || detail === 'consent-text-mismatch' || detail === 'consent-at-invalid') return '동의 내용이 최신이 아닙니다. 화면을 새로고침한 뒤 다시 접수해 주세요.';
    if (detail === 'invalid-name') return `${WALKIN_NAME_HINT}로 적어 주세요.`;
    if (detail === 'invalid-phone') return '휴대폰 번호를 010-0000-0000 형식으로 적어 주세요.';
    if (detail === 'invalid-purpose') return '내원 목적을 골라 주세요.';
    if (detail === 'rrn-not-allowed') return '이름 칸에는 이름만 적어 주세요.';
    // salt 미설정(계약 §F P1-2) — 그 외 failed-precondition 도 같은 안내
    if (detail === 'walkin-salt-missing' || code === 'failed-precondition') return '접수 준비가 되지 않았습니다. 데스크에 말씀해 주세요.';
    if (code === 'resource-exhausted') return '지금은 접수가 많습니다. 데스크에 말씀해 주세요.';
    if (code === 'not-found') return '확인할 수 없는 QR입니다. 데스크에 말씀해 주세요.';
    if (code === 'invalid-argument') return '입력한 내용을 다시 확인해 주세요.';
    // 같은 번호·같은 날 재접수인데 이름이 다름(walkin-name-mismatch, §F P1-3) — 기존 접수는 보존됨
    if (code === 'already-exists') return '같은 번호로 오늘 이미 접수된 이름과 다릅니다. 데스크에 말씀해 주세요.';
    if (code === 'unavailable' || code === 'deadline-exceeded' || code === 'internal') return '접수하지 못했습니다. 잠시 후 다시 눌러 주세요. 급하면 데스크에 말씀해 주세요.';
    return fallback || '접수하지 못했습니다. 데스크에 말씀해 주세요.';
}

// 치과 화면(「오늘」 접수 목록) 오류 문구
export function walkinListErrorMessage(e, fallback) {
    const code = String(e?.code || '').replace(/^functions\//, '');
    const detail = e?.details?.code;
    if (detail === 'feature-off') return '웹 접수 기능이 아직 열리지 않았습니다.';
    if (code === 'unauthenticated') return '로그인이 필요합니다. 다시 로그인해 주세요.';
    if (code === 'permission-denied') return '치과 계정만 사용할 수 있습니다.';
    if (code === 'resource-exhausted') return '요청이 많아 잠시 제한되었습니다. 잠시 후 다시 시도해 주세요.';
    if (detail === 'walkin-salt-missing' || code === 'failed-precondition') return '접수 준비가 되지 않았습니다. 덴탈클러스터에 문의해 주세요.';
    return fallback || '접수 목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
}

// 치과 화면(「오늘」 접수 목록 [연결]) 수동 연결 오류 문구 — callable linkClinicWalkin (§B-5)
export function walkinLinkErrorMessage(e) {
    const code = String(e?.code || '').replace(/^functions\//, '');
    const detail = e?.details?.code;
    if (detail === 'walkin-already-linked') return '이미 다른 환자와 연결된 접수입니다. 목록을 새로 고쳐 주세요.';
    if (code === 'not-found') return '접수 또는 환자 정보를 찾을 수 없습니다. 목록을 새로 고쳐 주세요.';
    if (code === 'unauthenticated') return '로그인이 필요합니다. 다시 로그인해 주세요.';
    if (code === 'permission-denied') return '치과 계정만 사용할 수 있습니다.';
    if (detail === 'walkin-salt-missing' || code === 'failed-precondition') return '접수 준비가 되지 않았습니다. 덴탈클러스터에 문의해 주세요.';
    return '연결하지 못했습니다. 잠시 후 다시 시도해 주세요.';
}

// 치과 설정(웹 접수 QR) 발급 오류 문구 — callable issueWalkinSlug (§F P2-6)
export function walkinSlugIssueErrorMessage(e) {
    const code = String(e?.code || '').replace(/^functions\//, '');
    const detail = e?.details?.code;
    if (code === 'unauthenticated') return '로그인이 필요합니다. 다시 로그인해 주세요.';
    if (code === 'permission-denied') return '치과 대표 계정만 만들 수 있습니다. 직원 계정이면 대표 계정으로 로그인해 주세요.';
    if (code === 'resource-exhausted') return 'QR 만들기는 1시간에 10회까지입니다. 잠시 후 다시 시도해 주세요.';
    if (detail === 'walkin-salt-missing' || code === 'failed-precondition') return '접수 준비가 되지 않았습니다. 덴탈클러스터에 문의해 주세요.';
    return 'QR을 만들지 못했습니다. 잠시 후 다시 시도해 주세요.';
}

// 서버 시각(ms | {_seconds} | ISO) → "오전 10:32"
export function formatWalkinTime(v) {
    if (!v) return '';
    const d = typeof v === 'number' ? new Date(v) : (v._seconds ? new Date(v._seconds * 1000) : new Date(v));
    if (Number.isNaN(d.getTime())) return '';
    const h = d.getHours(), m = String(d.getMinutes()).padStart(2, '0');
    return `${h < 12 ? '오전' : '오후'} ${h % 12 || 12}:${m}`;
}
